import { useLang } from '../i18n/LanguageContext';
import { LegalShell } from './Privacy';

export default function Terms() {
  const { t } = useLang();
  return (
    <LegalShell title="Terms & Conditions" updated="June 2026" flag={`${t('legal.reviewFlag')} ${t('legal.inputFlag')}`}>
      <div>
        <h2>1. Agreement</h2>
        <p>These Terms & Conditions govern your use of the Gyeno website and platform, operated by DulipTech. By creating an account or using the service you agree to these terms.</p>
      </div>
      <div>
        <h2>2. The service</h2>
        <p>Gyeno is a Salesforce-native platform for building, testing, and deploying AI agents inside your Salesforce org. You must maintain an active Salesforce org; your use of Salesforce remains subject to Salesforce's own terms.</p>
      </div>
      <div>
        <h2>3. Accounts</h2>
        <p>You must provide accurate business information and keep credentials confidential. Accounts are for business use. You are responsible for all activity under your account.</p>
      </div>
      <div>
        <h2>4. AI Credits model</h2>
        <ul>
          <li>There is no subscription fee. Agent building is free and unlimited; predefined agents are free to use.</li>
          <li>A one-time minimum purchase of USD $49 in AI Credits is required to activate an account for running agents.</li>
          <li>Credits are consumed based on usage, including LLM calls and action executions. Published consumption rates apply once finalized.</li>
          <li><strong>Credit expiry:</strong> [NEEDS BUSINESS INPUT — expiry policy not yet finalized.]</li>
          <li><strong>Refunds:</strong> [NEEDS BUSINESS INPUT — refund policy for unused credits not yet finalized.]</li>
          <li><strong>Usage limits:</strong> [NEEDS BUSINESS INPUT — fair-use / rate limits to be defined.]</li>
        </ul>
      </div>
      <div>
        <h2>5. Support</h2>
        <p>New accounts receive 14 days of premium implementation support. Ongoing support terms for enterprise customers are set in their order form.</p>
      </div>
      <div>
        <h2>6. Acceptable use</h2>
        <p>You may not use the service to violate law, infringe rights, send spam, attempt to breach security, or build agents that impersonate others or harvest credentials.</p>
      </div>
      <div>
        <h2>7. Third-party AI models</h2>
        <p>Agent output is generated by third-party LLM providers (Anthropic, OpenAI, Google). Output may contain errors; you are responsible for reviewing agent behavior before and after publishing. BYOK customers are additionally bound by their own provider agreements.</p>
      </div>
      <div>
        <h2>8. Intellectual property</h2>
        <p>We retain all rights in the platform, brand, and documentation. You retain rights in your Salesforce data and agent configurations.</p>
      </div>
      <div>
        <h2>9. Disclaimers & liability</h2>
        <p>The service is provided "as is". To the maximum extent permitted by law, our aggregate liability is limited to the amounts you paid in the 12 months preceding the claim. Nothing limits liability that cannot be limited by law.</p>
      </div>
      <div>
        <h2>10. Changes & termination</h2>
        <p>We may update these terms with notice. You may stop using the service at any time; we may suspend accounts for material breach. Sections that by nature survive termination will survive.</p>
      </div>
      <div>
        <h2>11. Governing law</h2>
        <p>[NEEDS BUSINESS INPUT — governing law and venue to be confirmed by counsel.]</p>
      </div>
    </LegalShell>
  );
}
